import React, { useState } from 'react';
import '../components/css/ValidatorSetupPopup.css';

const ValidatorSetupPopup = ({ chainName = 'terra_classic', onClose }) => {
  const [show, setShow] = useState(true);
  const isLuna = chainName === 'luna';
  const chainLabel = isLuna ? 'Terra LUNA' : 'Terra Classic';

  const handleClose = () => {
    setShow(false);
    if (onClose) onClose(); // Call parent close if provided
  };

  if (!show) return null;
return (
  <div className="validator-setup-popup">
    <div className="popup-inner">
      <h2>How to Create a {chainLabel} Validator</h2>
      <ul>
        <li>Contact DNC / David Coulson to request an IP address for your validator — this will be provided by us.</li>
        <li>Fill in your validator details (name, commission, website, etc.).</li>
        <li>Your validator name (moniker) can contain spaces. Keep it short; you can change it later if needed.</li>
        <li>Enter your validator wallet address and seed phrase, or use Generate wallet and save the new recovery phrase securely.</li>
        {!isLuna && <li>Enter a separate Terra Classic oracle feeder wallet and seed phrase, or generate one here.</li>}
        {isLuna && <li>Use a dedicated Phoenix-1 wallet with enough LUNA for the self-delegation and transaction fee.</li>}
        <li><strong>We do NOT store or retain any seed phrases.</strong></li>
        <li>Confirm and start the setup process.</li>
        <li>The system will fully automate the setup via SSH.</li>
        <li>You will receive a success message once your validator is live.</li>
        <li>Each validator runs on its own dedicated server to protect the integrity of the {isLuna ? 'LUNA' : 'LUNC'} blockchain.</li>
        <li>For further help, contact David Coulson on Telegram: <a href="https://t.me/luncunited" target="_blank" rel="noopener noreferrer">https://t.me/luncunited</a></li>
      </ul>
      <p><strong>Note:</strong> The full setup process may take between <strong>90–180 minutes </strong>once started.</p>
 
      <button onClick={handleClose}>Close</button>
    </div>
  </div>
);

}
export default ValidatorSetupPopup;
